"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeightMedium = exports.fontWeightBook = exports.fontTextDecorationNone = exports.fontTextCaseNone = exports.fontSize46 = exports.fontSize36 = exports.fontSize26 = exports.fontSize24 = exports.fontSize18 = exports.fontSize16 = exports.fontSize14 = exports.fontSize13 = exports.fontSize12 = exports.fontParagraphSpacing0 = exports.fontLineHeight170 = exports.fontLineHeight150 = exports.fontLineHeight140 = exports.fontLineHeight130 = exports.fontLineHeight125 = exports.fontLineHeight120 = exports.fontLineHeight100 = exports.fontLetterSpacingMinus4 = exports.fontLetterSpacingMinus3 = exports.fontLetterSpacingMinus2 = exports.fontLetterSpacingMinus1 = exports.fontLetterSpacing4 = exports.fontLetterSpacing2 = exports.fontLetterSpacing1 = exports.fontLetterSpacing0 = exports.fontFamilyCentra = void 0;

const fontFamilyCentra = '"Centra No 2"';
exports.fontFamilyCentra = fontFamilyCentra;
const fontWeightBook = '400';
exports.fontWeightBook = fontWeightBook;
const fontWeightMedium = '500';
exports.fontWeightMedium = fontWeightMedium;
const fontSize12 = '12px';
exports.fontSize12 = fontSize12;
const fontSize13 = '13px';
exports.fontSize13 = fontSize13;
const fontSize14 = '14px';
exports.fontSize14 = fontSize14;
const fontSize16 = '16px';
exports.fontSize16 = fontSize16;
const fontSize18 = '18px';
exports.fontSize18 = fontSize18;
const fontSize24 = '24px';
exports.fontSize24 = fontSize24;
const fontSize26 = '26px';
exports.fontSize26 = fontSize26;
const fontSize36 = '36px';
exports.fontSize36 = fontSize36;
const fontSize46 = '46px';
exports.fontSize46 = fontSize46;
const fontLetterSpacing0 = '0em';
exports.fontLetterSpacing0 = fontLetterSpacing0;
const fontLetterSpacing1 = '0.01em';
exports.fontLetterSpacing1 = fontLetterSpacing1;
const fontLetterSpacing2 = '0.02em';
exports.fontLetterSpacing2 = fontLetterSpacing2;
const fontLetterSpacing4 = '0.04em';
exports.fontLetterSpacing4 = fontLetterSpacing4;
const fontLetterSpacingMinus1 = '-0.01em';
exports.fontLetterSpacingMinus1 = fontLetterSpacingMinus1;
const fontLetterSpacingMinus2 = '-0.02em';
exports.fontLetterSpacingMinus2 = fontLetterSpacingMinus2;
const fontLetterSpacingMinus3 = '-0.03em';
exports.fontLetterSpacingMinus3 = fontLetterSpacingMinus3;
const fontLetterSpacingMinus4 = '-0.04em';
exports.fontLetterSpacingMinus4 = fontLetterSpacingMinus4;
const fontLineHeight100 = '100%';
exports.fontLineHeight100 = fontLineHeight100;
const fontLineHeight120 = '120%';
exports.fontLineHeight120 = fontLineHeight120;
const fontLineHeight125 = '125%';
exports.fontLineHeight125 = fontLineHeight125;
const fontLineHeight130 = '130%';
exports.fontLineHeight130 = fontLineHeight130;
const fontLineHeight140 = '140%';
exports.fontLineHeight140 = fontLineHeight140;
const fontLineHeight150 = '150%';
exports.fontLineHeight150 = fontLineHeight150;
const fontLineHeight170 = '170%';
exports.fontLineHeight170 = fontLineHeight170;
const fontParagraphSpacing0 = '0';
exports.fontParagraphSpacing0 = fontParagraphSpacing0;
const fontTextCaseNone = 'none';
exports.fontTextCaseNone = fontTextCaseNone;
const fontTextDecorationNone = 'none';
exports.fontTextDecorationNone = fontTextDecorationNone;